export default __webpack_public_path__ + "static/media/NCRlogo.f58a4c52.png";